import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import imgPlaceholder from '../../../../assets/images/image-placeholder.svg';
import SelectionButton from '../../../../components/SelectionButton';

import { setSelected } from '../actions';

const SectionBtn = ({
  selected,
  marginTop,
  section: {
    key,
    label,
    data,
    options,
    value,
    customIconData,
  },
  setSelectedAction,
}) => {
  let imgUrl;
  if (options && options[value]) {
    if (value === 'custom' && customIconData?.srsIconUrl) {
      imgUrl = customIconData.srsIconUrl;
    } else {
      imgUrl = options[value].imageSrc;
    }
  } else {
    imgUrl = data[`${key}Url`];
  }

  const classes = classnames({ 'mt-2': marginTop });
  const imageSrc = imgUrl || imgPlaceholder;
  const hasTransparentBg = key === 'venueType';

  return (
    <SelectionButton
      label={label}
      selected={selected}
      className={classes}
      imageSrc={imageSrc}
      onClick={setSelectedAction}
      hasTransparentBg={hasTransparentBg}
    />
  );
};

export default connect(
  ({ graphics: { sections, selectedInd } }, { index }) => ({
    selected: selectedInd === index,
    marginTop: index !== 0,
    section: sections[index],
  }),
  (dispatch, { index }) => ({
    setSelectedAction: () => dispatch(setSelected(index)),
  }),
)(SectionBtn);
